import { render } from "./reservations-list.vue?vue&type=template&id=f80bb466"
import script from "./reservations-list.vue?vue&type=script&lang=js"
export * from "./reservations-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__